import React from 'react';
import { Avatar, Box } from '@mui/material';
import { colorPrimary } from '../../Styles/Colors';

const Monogram = ({
  name = "User",
  size = 40,
  backgroundColor = colorPrimary,
  color = "white",
  fontSize,
  onClick,
  variant = "circular", // circular, rounded, square
  sx = {}
}) => {
 
  const getInitials = (fullName) => {
    if (!fullName) return "U";
    
    const names = fullName.trim().split(" ");
    if (names.length === 1) {
      return names[0].charAt(0).toUpperCase();
    }
    return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
  };

  const getBorderRadius = () => {
    switch (variant) {
      case 'square': return 0;
      case 'rounded': return 1;
      case 'circular':
      default: return '50%';
    }
  };

  return (
    <Avatar
      onClick={onClick}
      sx={{
        width: size,
        height: size,
        backgroundColor,
        color,
        fontSize: fontSize || size * 0.4,
        fontWeight: 500,
        cursor: onClick ? 'pointer' : 'default',
        borderRadius: getBorderRadius(),
        transition: 'all 0.2s ease',
        '&:hover': onClick ? {
          transform: 'scale(1.1)',
          boxShadow: 1
        } : {},
        ...sx
      }}
    >
      {getInitials(name)}
    </Avatar>
  );
};

export default Monogram;